import { Ng1StateDeclaration } from '@uirouter/angularjs';

import * as Resolve from '../Resolve';
import { Roles } from '../../common/constants';

const states: Ng1StateDeclaration[] = [
    {
        name: 'dashboards',
        url: '/dashboards/:categoryGuid?',
        component: 'wtDashboardsState',
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            roles: Resolve.rolesResolve([Roles.master, Roles.engineer, Roles.operator, Roles.reader])
        },
        data: {
            visible: true,
            isMobileVisible: true,
            sortingOrder: 2,
            isAuthenticated: true,
            isConnected: true,
            icon: 'fa-th-large',
            displayName: 'Dashboards',
            editRoles: [Roles.master, Roles.engineer],
            editButtonVisibility: () => true,
            subMenu: {
                subState: 'dashboard'
            }
        },
        params: {
            categoryGuid: ''
        }
    }];

export default states;